//@ts-nocheck

import styled, { css } from "styled-components";
import { FC } from "react";
import { FInter } from "@brg/ui";
import { LayoutConst } from "../../../core";
import { AppTester } from "supporting";

const getFontSize = (count?: number) => {
  if (count < 10) {
    return 12;
  }
  if (count < 100) {
    return 9;
  }
  return 7;
};

const BellWrapper = styled.div`
  position: relative;
  cursor: pointer;

  // @media (max-width: ${LayoutConst.screen.l}px) {
  //   margin-left: 16px;
  // }

  // @media (max-width: ${LayoutConst.screen.m_1024}px) {
  //   margin-left: 16px;
  // }

  // @media (max-width: ${LayoutConst.screen.md}px) {
  //   margin-right: 16px;
  // }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    margin-right: 11px;
    
    svg {
      height: 24px;
      width: 24px;
    }
  }

  @media (max-width: 500px) {
    margin: 0;
  }
`
export const Circle = styled.div<{ isHSEDesign?: boolean, shrinkable?: boolean, isGreenAward?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  height: 15px;
  width: 15px;
  border-radius: 7.5px;
  background: ${({isHSEDesign, isGreenAward}) => 
    isGreenAward ? "#89B644" : 
    isHSEDesign ? "#146DEE" : 
    ({ theme}) => theme.navigationBar.backgroundDirtyColor || '#FF0000'};
  display: flex;
  align-items: center;
  justify-content: center;

  ${({shrinkable}) => shrinkable ? css`
  @media (max-width: ${LayoutConst.screen.sm}px) {
      top: 4px;
      right: 5px;
      height: 6.34px;
      width: 6.34px;
      //@ts-ignore
      ${FInter.SmallText} {
        display: none;
      }
  }` : null}
`

export const Count = styled(FInter.SmallText)<{ count?: number, isBlackText?: boolean}>`
  font-size: ${({ count }) => getFontSize(count)}px;
  line-height: 8px;
  color: ${({isBlackText}) => isBlackText ? '#151514' : '#FFFFFF'} !important;
  font-weight: 500;
`

const NotificationBellIcon: FC<{ unreadCount?: number, iconRef?: any, onClickCB?: any }> = ({ unreadCount = 0, iconRef, onClickCB }) => {
  const isHSEDesign = AppTester.isHSEDesign();
  const isGreenAward = AppTester.isGreenAward();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isJhonata = AppTester.isJhonataNet();

  return (
    <BellWrapper className="navbar-icon-hover" onClick={onClickCB} ref={iconRef}>
      {unreadCount > 0 && (
        <Circle shrinkable isHSEDesign={isHSEDesign} isGreenAward={isGreenAward}>
          <Count count={unreadCount} isBlackText={isGameDeziiign || isJhonata}>
            {unreadCount}
          </Count>
        </Circle>
      )}
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.94972 19.209L6.94973 19.209C6.97831 19.1911 7.00732 19.1731 7.03667 19.1549C7.32379 18.9766 7.64306 18.7783 7.90421 18.4777C8.20692 18.1293 8.40822 17.6791 8.53328 17.0256L9.63328 11.2769C9.92473 9.75373 10.6154 8.33963 11.6919 7.28584C12.7983 6.20282 14.432 5.49997 16 5.5C17.5681 5.50003 19.2016 6.20279 20.3081 7.28584C21.3846 8.33963 22.0753 9.75373 22.3667 11.2769L23.4667 17.0256C23.5918 17.6791 23.7931 18.1293 24.0958 18.4777C24.3569 18.7783 24.6762 18.9766 24.9633 19.1548C24.9927 19.1731 25.0217 19.1911 25.0503 19.209L25.0503 19.209C25.0985 19.2392 25.1462 19.2686 25.1934 19.2977C25.4975 19.4851 25.7789 19.6585 26.0348 19.9438C26.3036 20.2434 26.5 20.7001 26.5 21.2513C26.5 22.0959 25.7528 22.8417 24.8 22.8417H20.1164H19.6502L19.6176 23.3068C19.4945 25.0623 17.9355 26.5 16 26.5C14.0645 26.5 12.5055 25.0623 12.3824 23.3068L12.3498 22.8417H11.8836H7.2C6.24724 22.8417 5.5 22.0959 5.5 21.2513C5.5 20.7001 5.69642 20.2435 5.96516 19.9438C6.22114 19.6585 6.50249 19.4851 6.80662 19.2977C6.85377 19.2686 6.90148 19.2392 6.94972 19.209ZM25.5245 20.2887L25.5245 20.2886C25.4209 20.1732 25.287 20.0699 25.1551 19.9775C25.019 19.8823 24.8559 19.779 24.6786 19.668C24.0135 19.2515 23.1072 18.5469 22.8333 17.1153L21.7333 11.3666C21.4602 9.93968 20.7939 8.60903 19.8216 7.65727C18.8424 6.69869 17.5842 6.11823 16 6.11823C14.4158 6.11823 13.1576 6.69869 12.1784 7.65727C11.2061 8.60903 10.5398 9.93968 10.2667 11.3666L9.16672 17.1153C8.89278 18.5469 7.98654 19.2515 7.32136 19.668C7.14405 19.779 6.98103 19.8823 6.84493 19.9775C6.71297 20.0699 6.57905 20.1732 6.47548 20.2886L6.47545 20.2887C6.39625 20.377 6.29623 20.4979 6.23028 20.6808C6.16858 20.852 6.15 21.0397 6.15 21.2513C6.15 21.8543 6.62927 22.2739 7.2 22.2739H24.8C25.3707 22.2739 25.85 21.8543 25.85 21.2513C25.85 21.0397 25.8314 20.852 25.7697 20.6808C25.7038 20.4979 25.6038 20.377 25.5245 20.2887ZM13.5766 22.8417H13.0141L13.08 23.4003C13.2499 24.8411 14.4653 25.9322 16 25.9322C17.5347 25.9322 18.7501 24.8411 18.92 23.4003L18.9859 22.8417H18.4234H13.5766Z"
          stroke="#909090"/>
      </svg>
    </BellWrapper>
  )
}

export default NotificationBellIcon;//@ts-nocheck

import styled, { css } from "styled-components";
import { FC } from "react";
import { FInter } from "@brg/ui";
import { LayoutConst } from "../../../core";
import { AppTester } from "supporting";

const getFontSize = (count?: number) => {
  if (count < 10) {
    return 12;
  }
  if (count < 100) {
    return 9;
  }
  return 7;
};

const BellWrapper = styled.div`
  position: relative;
  cursor: pointer;

  // @media (max-width: ${LayoutConst.screen.l}px) {
  //   margin-left: 16px;
  // }

  // @media (max-width: ${LayoutConst.screen.m_1024}px) {
  //   margin-left: 16px;
  // }

  // @media (max-width: ${LayoutConst.screen.md}px) {
  //   margin-right: 16px;
  // }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    margin-right: 11px;
    
    svg {
      height: 24px;
      width: 24px;
    }
  }

  @media (max-width: 500px) {
    margin: 0;
  }
`
export const Circle = styled.div<{ isHSEDesign?: boolean, shrinkable?: boolean, isGreenAward?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  height: 15px;
  width: 15px;
  border-radius: 7.5px;
  background: ${({isHSEDesign, isGreenAward}) => 
    isGreenAward ? "#89B644" : 
    isHSEDesign ? "#146DEE" : 
    ({ theme}) => theme.navigationBar.backgroundDirtyColor || '#FF0000'};
  display: flex;
  align-items: center;
  justify-content: center;

  ${({shrinkable}) => shrinkable ? css`
  @media (max-width: ${LayoutConst.screen.sm}px) {
      top: 4px;
      right: 5px;
      height: 6.34px;
      width: 6.34px;
      //@ts-ignore
      ${FInter.SmallText} {
        display: none;
      }
  }` : null}
`

export const Count = styled(FInter.SmallText)<{ count?: number, isBlackText?: boolean}>`
  font-size: ${({ count }) => getFontSize(count)}px;
  line-height: 8px;
  color: ${({isBlackText}) => isBlackText ? '#151514' : '#FFFFFF'} !important;
  font-weight: 500;
`

const NotificationBellIcon: FC<{ unreadCount?: number, iconRef?: any, onClickCB?: any }> = ({ unreadCount = 0, iconRef, onClickCB }) => {
  const isHSEDesign = AppTester.isHSEDesign();
  const isGreenAward = AppTester.isGreenAward();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isJhonata = AppTester.isJhonataNet();

  return (
    <BellWrapper className="navbar-icon-hover" onClick={onClickCB} ref={iconRef}>
      {unreadCount > 0 && (
        <Circle shrinkable isHSEDesign={isHSEDesign} isGreenAward={isGreenAward}>
          <Count count={unreadCount} isBlackText={isGameDeziiign || isJhonata}>
            {unreadCount}
          </Count>
        </Circle>
      )}
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.94972 19.209L6.94973 19.209C6.97831 19.1911 7.00732 19.1731 7.03667 19.1549C7.32379 18.9766 7.64306 18.7783 7.90421 18.4777C8.20692 18.1293 8.40822 17.6791 8.53328 17.0256L9.63328 11.2769C9.92473 9.75373 10.6154 8.33963 11.6919 7.28584C12.7983 6.20282 14.432 5.49997 16 5.5C17.5681 5.50003 19.2016 6.20279 20.3081 7.28584C21.3846 8.33963 22.0753 9.75373 22.3667 11.2769L23.4667 17.0256C23.5918 17.6791 23.7931 18.1293 24.0958 18.4777C24.3569 18.7783 24.6762 18.9766 24.9633 19.1548C24.9927 19.1731 25.0217 19.1911 25.0503 19.209L25.0503 19.209C25.0985 19.2392 25.1462 19.2686 25.1934 19.2977C25.4975 19.4851 25.7789 19.6585 26.0348 19.9438C26.3036 20.2434 26.5 20.7001 26.5 21.2513C26.5 22.0959 25.7528 22.8417 24.8 22.8417H20.1164H19.6502L19.6176 23.3068C19.4945 25.0623 17.9355 26.5 16 26.5C14.0645 26.5 12.5055 25.0623 12.3824 23.3068L12.3498 22.8417H11.8836H7.2C6.24724 22.8417 5.5 22.0959 5.5 21.2513C5.5 20.7001 5.69642 20.2435 5.96516 19.9438C6.22114 19.6585 6.50249 19.4851 6.80662 19.2977C6.85377 19.2686 6.90148 19.2392 6.94972 19.209ZM25.5245 20.2887L25.5245 20.2886C25.4209 20.1732 25.287 20.0699 25.1551 19.9775C25.019 19.8823 24.8559 19.779 24.6786 19.668C24.0135 19.2515 23.1072 18.5469 22.8333 17.1153L21.7333 11.3666C21.4602 9.93968 20.7939 8.60903 19.8216 7.65727C18.8424 6.69869 17.5842 6.11823 16 6.11823C14.4158 6.11823 13.1576 6.69869 12.1784 7.65727C11.2061 8.60903 10.5398 9.93968 10.2667 11.3666L9.16672 17.1153C8.89278 18.5469 7.98654 19.2515 7.32136 19.668C7.14405 19.779 6.98103 19.8823 6.84493 19.9775C6.71297 20.0699 6.57905 20.1732 6.47548 20.2886L6.47545 20.2887C6.39625 20.377 6.29623 20.4979 6.23028 20.6808C6.16858 20.852 6.15 21.0397 6.15 21.2513C6.15 21.8543 6.62927 22.2739 7.2 22.2739H24.8C25.3707 22.2739 25.85 21.8543 25.85 21.2513C25.85 21.0397 25.8314 20.852 25.7697 20.6808C25.7038 20.4979 25.6038 20.377 25.5245 20.2887ZM13.5766 22.8417H13.0141L13.08 23.4003C13.2499 24.8411 14.4653 25.9322 16 25.9322C17.5347 25.9322 18.7501 24.8411 18.92 23.4003L18.9859 22.8417H18.4234H13.5766Z"
          stroke="#909090"/>
      </svg>
    </BellWrapper>
  )
}

export default NotificationBellIcon;